/**
 * milestonevideo-theme/video-hero — view.js
 * Przepisane 1:1 (wartości + kolejność) z hifi-blocks.jsx (VideoBG, Hero)
 * i hifi-sections.jsx (useReveal) — na vanilla JS.
 */
( function () {
	const roots = document.querySelectorAll( '.wp-block-milestonevideo-theme-video-hero' );
	if ( ! roots.length ) {
		return;
	}

	const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	roots.forEach( function ( root ) {
		initTypewriter( root, reduceMotion );
		initVideoBG( root );
		initReveal( root, reduceMotion );
	} );

	/* =================================================================
	 * 1. Typewriter hero — speed 72ms/znak, start 520ms, przerwa 350ms,
	 *    caret migający, stagefade badge/lead/CTA (1:1 z Hero() w hifi-blocks.jsx)
	 * ================================================================= */
	function initTypewriter( root, reduceMotion ) {
		const lineAEl = root.querySelector( '.vh__line-a' );
		const lineBEl = root.querySelector( '.vh__line-b' );
		const badgeWrap = root.querySelector( '.vh__badge-wrap' );
		const leadEl = root.querySelector( '.vh__lead' );
		const ctaEl = root.querySelector( '.vh__cta' );

		if ( ! lineAEl || ! lineBEl ) {
			return;
		}

		if ( reduceMotion ) {
			if ( badgeWrap ) badgeWrap.setAttribute( 'data-show', 'true' );
			if ( leadEl ) leadEl.setAttribute( 'data-show', 'true' );
			if ( ctaEl ) ctaEl.setAttribute( 'data-show', 'true' );
			return; // teksty zostają w pełni widoczne (bez per-literowego ukrywania)
		}

		const a = Array.from( lineAEl.textContent );
		const b = Array.from( lineBEl.textContent );

		const buildSpans = ( el, chars ) => {
			el.textContent = '';
			return chars.map( function ( ch ) {
				const span = document.createElement( 'span' );
				span.textContent = ch;
				span.style.visibility = 'hidden';
				el.appendChild( span );
				return span;
			} );
		};
		const spansA = buildSpans( lineAEl, a );
		const spansB = buildSpans( lineBEl, b );

		const caretA = document.createElement( 'span' );
		caretA.className = 'vh__caret';
		caretA.textContent = '▍';
		const caretB = document.createElement( 'span' );
		caretB.className = 'vh__caret';
		caretB.textContent = '▍';

		const moveCaret = ( parentEl, spans, caret, count ) => {
			if ( count < spans.length ) {
				parentEl.insertBefore( caret, spans[ count ] );
			} else {
				parentEl.appendChild( caret );
			}
		};

		// caret startuje przed pierwszą literą linii A (chars = 0, typingA = true od startu)
		moveCaret( lineAEl, spansA, caretA, 0 );

		const speed = 72;
		const start = 520;
		const gap = 350;
		const restDelay = 300;
		const timers = [];
		const setTimer = ( fn, delay ) => timers.push( setTimeout( fn, delay ) );

		for ( let i = 1; i <= a.length; i++ ) {
			setTimer( function () {
				spansA[ i - 1 ].style.visibility = 'visible';
				if ( i === 1 && badgeWrap ) badgeWrap.setAttribute( 'data-show', 'true' );
				moveCaret( lineAEl, spansA, caretA, i );
			}, start + i * speed );
		}

		const endA = start + a.length * speed + gap;

		setTimer( function () {
			if ( caretA.parentNode ) caretA.parentNode.removeChild( caretA );
			moveCaret( lineBEl, spansB, caretB, 0 );
		}, endA );

		for ( let i = 1; i <= b.length; i++ ) {
			setTimer( function () {
				spansB[ i - 1 ].style.visibility = 'visible';
				moveCaret( lineBEl, spansB, caretB, i );
			}, endA + i * speed );
		}

		const endB = endA + b.length * speed;

		setTimer( function () {
			if ( caretB.parentNode ) caretB.parentNode.removeChild( caretB );
			if ( leadEl ) leadEl.setAttribute( 'data-show', 'true' );
			if ( ctaEl ) ctaEl.setAttribute( 'data-show', 'true' );
		}, endB + restDelay );
	}

	/* =================================================================
	 * 2. Tło video — cover-fit z overscanem, veil fade, pętla (1:1 z VideoBG())
	 * ================================================================= */
	function initVideoBG( root ) {
		const bgWrap = root.querySelector( '.vh__bg' );
		const frame = root.querySelector( '.vh__frame' );
		const veil = root.querySelector( '.vh__veil' );
		const content = root.querySelector( '.vh__content' );
		const heroEl = root.querySelector( '.vh__hero' );
		const aboutEl = root.querySelector( '.vh__about' );

		if ( ! bgWrap || ! frame ) {
			return;
		}

		let revealed = false;
		const reveal = ( delay ) => {
			if ( revealed ) return;
			revealed = true;
			setTimeout( function () {
				frame.style.visibility = 'visible';
				if ( veil ) veil.style.opacity = '0';
			}, delay );
		};

		// Odroczone wstrzyknięcie src iframe — poza krytyczną ścieżką ładowania.
		// Guard "raz": kolejne wywołania (load + timeout) po pierwszym są no-op.
		let srcInjected = false;
		const injectSrc = () => {
			if ( srcInjected || frame.src ) return;
			srcInjected = true;
			frame.src = frame.getAttribute( 'data-vh-src' ) || '';

			// Fallback startuje dopiero od momentu wstrzyknięcia src — na wolnych
			// łączach veil nie odsłoni się zanim player w ogóle zacznie ładować.
			setTimeout( function () {
				reveal( 0 );
			}, 9000 );
		};

		if ( document.readyState === 'complete' ) {
			injectSrc();
		} else {
			window.addEventListener( 'load', injectSrc, { once: true } );
			setTimeout( injectSrc, 3500 ); // safety, gdyby load długo nie nadszedł
		}

		const onMsg = ( e ) => {
			if ( typeof e.data !== 'string' || ! e.origin.includes( 'youtube' ) ) return;
			if ( e.data.includes( '"playerState":1' ) ) reveal( 3000 ); // playing → poczekaj aż znikną kontrolki startowe
			if ( e.data.includes( '"playerState":0' ) ) {
				// pętla programowa: koniec filmu → seek do 0 (bez przeładowania → bez błysku kontrolek)
				if ( frame.contentWindow ) {
					frame.contentWindow.postMessage( '{"event":"command","func":"seekTo","args":[0,true]}', '*' );
					frame.contentWindow.postMessage( '{"event":"command","func":"playVideo","args":[]}', '*' );
				}
			}
		};
		window.addEventListener( 'message', onMsg );

		// poproś player o wysyłanie aktualizacji stanu
		const poke = setInterval( function () {
			if ( frame.contentWindow ) {
				frame.contentWindow.postMessage( '{"event":"listening","id":"vbg"}', '*' );
			}
		}, 400 );

		const fit = () => {
			let zoneH = bgWrap.parentElement ? bgWrap.parentElement.clientHeight : bgWrap.clientHeight;
			const isMobile = window.innerWidth <= 760;
			if ( heroEl && aboutEl ) {
				zoneH = isMobile ? heroEl.offsetHeight : heroEl.offsetHeight + aboutEl.offsetHeight * 0.5;
			} else if ( heroEl ) {
				zoneH = heroEl.offsetHeight;
			}
			bgWrap.style.height = zoneH + 'px';

			const w = bgWrap.clientWidth;
			const h = zoneH;
			const r = 16 / 9;
			let vw = w;
			let vh = w / r;
			if ( vh < h ) {
				vh = h;
				vw = h * r;
			}
			// silny overscan — kadr wychodzi poza tytuł/kontrolki YouTube
			vw *= 1.28;
			vh *= 1.28;
			frame.style.width = vw + 'px';
			frame.style.height = vh + 'px';
		};
		fit();
		const fitTimer = setTimeout( fit, 300 );
		const ro = new ResizeObserver( fit );
		if ( content ) ro.observe( content );
		window.addEventListener( 'resize', fit );
	}

	/* =================================================================
	 * 3. Reveal-on-scroll dla .reveal w obrębie bloku (delays d1/d2 1:1)
	 *    progi jak w exporcie: wejście przy top < 90% viewportu
	 *    → IntersectionObserver z rootMargin -10% od dołu.
	 * ================================================================= */
	function initReveal( root, reduceMotion ) {
		const els = root.querySelectorAll( '.reveal' );
		if ( ! els.length ) {
			return;
		}

		if ( reduceMotion ) {
			els.forEach( function ( el ) {
				el.classList.add( 'in' );
			} );
			return;
		}

		const io = new IntersectionObserver(
			function ( entries ) {
				entries.forEach( function ( entry ) {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( 'in' );
						io.unobserve( entry.target );
					}
				} );
			},
			{ threshold: 0, rootMargin: '0px 0px -10% 0px' }
		);

		els.forEach( function ( el ) {
			io.observe( el );
		} );
	}
} )();
